module.exports = __webpack_public_path__ + "img/no-address.9a8c3f25.png";